import React, {Component} from 'react';
import advanceIcon from './advance.png'
import advanceIcon_ from './advance_.png'
import {toolWidth} from "../../twoLinesEditorToolsSpace";
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

class AdvanceTool extends Component {

    state = {
        src : advanceIcon_
    };

    /**
     * 监听内容变化
     */
    listenContentChange(){
        let res = this.props.editor.queryCommandState('redo');
        if(res === -1){
            this.setState({src : advanceIcon_})
        }else{
            this.setState({src : advanceIcon})
        }
    }

    render() {
        return (
            <span style={{cursor:"pointer"}} onClick={()=>{
                this.props.editor.execCommand( 'redo' );
            }}>
                <img className={"editor-advance-tool-btn"} width={toolWidth} src={this.state.src} />
                <style>{`
                .editor-advance-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-advance-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-advance-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style>
            </span>
        );
    }
}

export default AdvanceTool;